<template>
  <div>
    <div class="modal is-active">
      <div @click="close" class="modal-background"></div>
      <div class="modal-content">
        <div class="card">
          <div class="card-content">
            <div class="content">
              <div>
                <p>Site URL: {{ record.site_url }}</p>
                <p>User Email: {{ record.user_email }} </p>
                <p>Preference Keyword: {{ record.pref_keyword }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button @click="close" class="modal-close is-large" aria-label="close"></button>
    </div>
  </div>
</template>

<script>

export default {
  props: ['record'],
  methods: {
    close() {
      this.$emit("close")
    },
  },
}
</script>
